
namespace TabAurous.JobWork {

    @Serenity.Decorators.registerClass()
    export class JobWorkReturnTaxGrid extends Serenity.EntityGrid<JobWorkReturnTaxRow, any> {
        protected getColumnsKey() { return 'JobWork.JobWorkReturnTax'; }
        protected getIdProperty() { return JobWorkReturnTaxRow.idProperty; }
        protected getInsertPermission() { return JobWorkReturnTaxRow.insertPermission; }
        protected getLocalTextPrefix() { return JobWorkReturnTaxRow.localTextPrefix; }
        protected getService() { return JobWorkReturnTaxService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}